import { formatIsoDate } from "@/utils/date-format";
import { isValidAuditRemark } from "../sabil-data/requires-sabil-edit-audit-remark";

export const SABIL_RECEIPT_AUDIT_REMARK_LABEL = "Reason for change";
export const SABIL_RECEIPT_AUDIT_REMARK_HELPER =
  "Required when changing receipt amount or date (minimum 5 characters).";

type SabilReceiptEditFormValues = Record<string, unknown>;

export function requiresSabilReceiptEditAuditRemark(
  data: SabilReceiptEditFormValues,
  previousData?: SabilReceiptEditFormValues
): boolean {
  const prevAmount = Number(previousData?.amount ?? data.amount ?? 0);
  const nextAmount = Number(data.amount ?? prevAmount);
  if (nextAmount !== prevAmount) {
    return true;
  }

  const prevDate = previousData?.receiptDate ? formatIsoDate(String(previousData.receiptDate)) : "";
  const nextDate = data.receiptDate ? formatIsoDate(String(data.receiptDate)) : prevDate;
  return nextDate !== prevDate;
}

export function validateSabilReceiptEditAuditRemark(
  data: SabilReceiptEditFormValues,
  previousData?: SabilReceiptEditFormValues
): string | undefined {
  if (!requiresSabilReceiptEditAuditRemark(data, previousData)) {
    return undefined;
  }
  if (!isValidAuditRemark(data.auditRemark)) {
    return SABIL_RECEIPT_AUDIT_REMARK_HELPER;
  }
  return undefined;
}

export function transformSabilReceiptEdit(
  data: SabilReceiptEditFormValues
): Record<string, unknown> {
  const payload: Record<string, unknown> = {
    id: data.id,
    amount: data.amount,
    receiptDate: data.receiptDate,
    paymentMode: data.paymentMode,
    remarks: data.remarks,
    transactionId: data.transactionId !== undefined ? data.transactionId || null : undefined,
  };
  if (data.auditRemark) {
    payload.auditRemark = String(data.auditRemark).trim();
  }
  return payload;
}
